import useUserPermissions from './useUserPermissions';
import useMe from './useMe';

function useAccessibleEndpointsByGroups(endpointGroups) {
    const {data: permissions = []} = useUserPermissions();
    const {data: currentUser} = useMe();

    if (currentUser?.role === 'Admin') {
        return endpointGroups.map(group => group.name);
    }

    const permissionMap = new Map(
        permissions.map((perm) => [perm.key, perm.status])
    );

    const isAllowed = (endpointOrSubarray) => {
        if (Array.isArray(endpointOrSubarray)) {
            return endpointOrSubarray.every((ep) => permissionMap.get(ep));
        } else {
            return permissionMap.get(endpointOrSubarray);
        }
    };

    return endpointGroups
        .filter((group) =>
            group.endpoints.some(isAllowed)
        )
        .map((group) => group.name);
}

export default useAccessibleEndpointsByGroups;
